<script lang="ts">
  import PersonBadge from './PersonBadge.svelte';
  import TagBadge from './TagBadge.svelte';
  import TeamBadge from './TeamBadge.svelte';
  import UserBadge from './UserBadge.svelte';
  import type { SearchHitData } from './values.types';

  /** A hit of the big search as its module shows it. */
  const { person, user, team, tag, text }: SearchHitData = $props();
</script>

{#if person}
  <PersonBadge {person} />
{:else if user}
  <UserBadge {user} />
{:else if team}
  <TeamBadge {team} />
{:else if tag}
  <TagBadge {tag} />
{:else}
  <strong>{text}</strong>
{/if}
